<template>
    <router-link :to="{ name: routeName, params: routeParams }" :title="text.edit + ' ' + linkName">{{text.edit}}</router-link>
</template>

<script>
    import lang from "@/shared/lang";

    export default {
        name: "EditAction",
        props: {
            routeName: {
                type: String
            },
            routeParams: {
                type: Object
            },
            linkName: {
                type: String
            }
        },
        computed: {
            text() {
                return lang;
            },
        },
    }
</script>